<div class="docs-page">

  <div *ngIf="hasEquipmentImage; else noImage">

    <button class="download-button"
            (click)="downloadImage()">
      Download billede
    </button>

  </div>

  <ng-template #noImage>

    <p>Der findes ikke nogle billeder af dette udstyr</p>

  </ng-template>

</div>
